import React from 'react';

/**
 * SettingsPreferences - System preferences tab component
 * Contains: weight unit, date format settings
 */
const SettingsPreferences = ({
  preferences,
  setPreferences,
  onSave,
  loading
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(preferences);
  };

  return (
    <div className="settings-section compact">
      <div className="section-header">
        <h2>System Preferences</h2>
      </div>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-row">
          <div className="form-group">
            <label>Weight Unit</label>
            <select
              value={preferences.weightUnit}
              onChange={(e) => setPreferences({ ...preferences, weightUnit: e.target.value })}
            >
              <option value="kg">Kilograms (kg)</option>
              <option value="lbs">Pounds (lbs)</option>
            </select>
          </div>

          <div className="form-group">
            <label>Date Format</label>
            <select
              value={preferences.dateFormat}
              onChange={(e) => setPreferences({ ...preferences, dateFormat: e.target.value })}
            >
              <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              <option value="DD/MM/YYYY">DD/MM/YYYY</option>
              <option value="YYYY-MM-DD">YYYY-MM-DD</option>
            </select>
          </div>
        </div>

        <button type="submit" className="save-btn" disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
      </form>
    </div>
  );
};

export default SettingsPreferences;
